
import { IGanttEvent, IGanttSeries } from "@directives/_visualisations/ganttChart/ganttChart.component";
import { IJourney } from "@interfaces/IJourney";
import { IPlot } from "@interfaces/IPlot";
import { PlotService } from "@services/plot.service";
import { VeriDate } from "@services/veriDate.service";
import * as angular from "angular";
import "./driverActivityGantt.scss";

interface IDriverActivityGanttComponentBindings {
    journey: IJourney;
}

class DriverActivityGanttController implements angular.IComponentController, IDriverActivityGanttComponentBindings {

    journey: IJourney;
    ganttSeries: IGanttSeries[] = [];

    static $inject = ["plotService", "veriDate"];

    constructor(
        private plotService: PlotService,
        private veriDate: VeriDate) {
    }

    $onInit(): void {
    }

    $onChanges(onChangesObj: angular.IOnChangesObject): void {
        if (onChangesObj["journey"] && this, this.journey) {

            this.processJourney();
        }
    }

    private processJourney() {

        this.ganttSeries = [];

        if (this.journey.events && this.journey.events.length !== 0) {
            const eventSeries: IGanttSeries = {
                title: "Events",
                className: "events",
                isIconSeries: true,
                events: []
            }

            this.journey.events.forEach(event => {
                eventSeries.events.push({
                    startUtc: event.plot.UtcMoment,
                    icon: event.options
                });
            });

            this.ganttSeries.push(eventSeries);
        }

        const transitSeries: IGanttSeries = { title: "In Transit", events: [] };
        this.ganttSeries.push(transitSeries);

        let wasMoving = false;
        let currentTransitEvent: IGanttEvent;
        let lastPlot: IPlot = null;

        this.journey.plots.forEach(plot => {
            // In transit
            var isMoving = this.plotService.isMoving(plot);

            if (isMoving !== wasMoving) {
                if (isMoving) {
                    currentTransitEvent = { startUtc: plot.UtcMoment };
                    transitSeries.events.push(currentTransitEvent);
                } else {
                    currentTransitEvent.endUtc = plot.UtcMoment;
                }

                wasMoving = isMoving;
            }

            lastPlot = plot;
        });
    }
}

export class DriverActivityGanttComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
            journey: "<"
        };

        this.controller = DriverActivityGanttController;
        this.template = require("./driverActivityGantt.html");
    }
}
